"use client";

import { ContentItem } from "@api";
import React, { useMemo } from "react";
import { ReusableBatteriesCard } from "../ReusableBatteriesSection";
import BaseSlider from "@/components/BaseSlider/BaseSlider";

interface IReusableBatteriesSwiperProps {
  pageContent: Record<string, ContentItem>;
}

const ReusableBatteriesSwiper = React.memo<IReusableBatteriesSwiperProps>(({
  pageContent,
}) => {
  const cardIndices = useMemo(() => [1, 2, 3, 4], []);

  return (
    <BaseSlider
      sliderProps={{
        spaceBetween: 24,
        breakpoints: {
          320: { slidesPerView: 1.3 },
          600: { slidesPerView: 2.1 },
        },
      }}
    >
      {cardIndices.map((cardIndex) => (
        <ReusableBatteriesCard
          key={`swiper-reusable-batteries-card-${cardIndex}`}
          pageContent={pageContent}
          cardIndex={cardIndex}
        />
      ))}
    </BaseSlider>
  );
});

ReusableBatteriesSwiper.displayName = 'ReusableBatteriesSwiper';

export default ReusableBatteriesSwiper;
